import './_mappings';
import { RootPage } from '../page';
import $api from '../../api';
import { ButtonModel } from '../../models/Gen/TrackableBaseModels';
import { ButtonItemDescriptor, ButtonContentDescriptor } from '../../site-config/trackableConfig';
import ButtonWidgetComponent from './components/buttonWidget';
import BadgeDescriptorComponent from './components/badgeDescriptor';
import languages from '../../utils/languages';
import ColorPicker from '../../components/colorPicker';
import UrlFilterDescriptorComponent from '../../components/descriptors/urlFilterDescriptor';
import RulesDescriptorComponent from '../../components/descriptors/rulesDescriptor';
import BtnItemTour from './components/items/tour';
import BtnItemGroup from './components/items/group';
import BtnItemHeader from './components/items/header';
import BtnItemLink from './components/items/link';
import BtnKbArticle from './components/items/kb-article';
import BtnItemVideoModal from './components/items/videoModal';
import SegmentationSelector from '../../components/segmentationSelector';
import { koComponent } from '../../ko-utils';
import { listenToPageDirty, resolvePageDirty, beginNoTracking, endNoTracking } from '../../utils/changeTracking';
import createUUID from '../../utils/uuid';

class ButtonOverviewView extends RootPage {
    constructor() {
        super();

        this.deferUpdates = true;

        this.isDirty = ko.observable(false);

        ColorPicker();
        ButtonWidgetComponent(this);
        BadgeDescriptorComponent(this);
        UrlFilterDescriptorComponent(this);
        RulesDescriptorComponent(this);
        SegmentationSelector(this);

        BtnItemTour();
        BtnItemGroup();
        BtnItemHeader();
        BtnItemLink();
        BtnKbArticle();
        BtnItemVideoModal();

        this.button = ko.observable();

        this.setActiveTab('button');

        this.selectedLanguage = ko.observable(window.auth.project.SupportedLanguages[0]);
        this.supportedLanguages = languages.filter(i => window.auth.project.SupportedLanguages.indexOf(i.alpha2) !== -1);

        this.icons = [
            { value: '', text: 'Life Ring' },
            { value: 'life-ring-2', text: 'Life Ring 2' },
            { value: 'question-mark', text: 'Question Mark' }
        ];

        this.channels = this.getServerSideData('channels');
        this.chatProviders = [
            { id: 'crsp', name: 'Crisp' },
            { id: 'frsh_c', name: 'Freshdesk Messaging (Chat)' },
            { id: 'frsh_w', name: 'Freshdesk Widget' },
            //{ id: 'drft', name: 'Drift' }
            { id: 'intc', name: 'Intercom' },
            { id: 'supb', name: 'SupportBox' },
            { id: 'zen', name: 'ZenDesk (Web Widget)' },
            { id: 'zop', name: 'ZenDesk (Zopim/Live Chat)' },
            { id: 'custom', name: 'Custom Provider (via JS API)' },
        ];

        this.selectedItem = ko.observable();
        this.selectedItemComponentName = ko.computed(() => {
            const selItem = ko.unwrap(this.selectedItem);
            const type = selItem ? ko.unwrap(selItem.type) : '';

            if (type == 'tour') {
                return 'btn-item-tour';
            } else if (type == 'h') {
                return 'btn-item-header';
            } else if (type == 'link') {
                return 'btn-item-link';
            } else if (type == 'grp') {
                return 'btn-item-grp';
            } else if (type == 'vm') {
                return 'btn-item-video-modal';
            } else if (type == 'kb-article') {
                return 'btn-item-kb-article';
            }
        });
        this.selectedItemComponentParams = ko.computed(() => {
            return {
                item: ko.unwrap(this.selectedItem),
                selectedLanguage: this.selectedLanguage,
                onUpdated: () => this.updatePreview(),
                dialogApi: {
                    show: this.showStandardDialog.bind(this)
                }
            }
        });

        this.toolButtonsStyles = [
            { val: 'i', text: 'Icons with tooltips' },
            { val: 't', text: 'Text' },
            { val: 'it', text: 'Icons with text' },
        ];

        this.itemsRoot = ko.observable();

        this.chatButtonEnabled = ko.computed({
            read: () => {
                return this.descriptor && !!ko.unwrap(this.descriptor.chat);
            },
            write: (val) => {
                this.descriptor.chat(val ? 'zen' : null);
            }
        });

        koComponent('lifering-items-list', LifeRingItemsList)({
            selectedItem: this.selectedItem,
            selectItem: this.selectItem.bind(this),
            getTypeDisplayName: this.getTypeDisplayName.bind(this),
            bindLocalizableProp: this.bindLocalizableProp.bind(this),
            removeItem: this.removeItem.bind(this),
            onUpdated: () => {
                setTimeout(() => { this.updatePreview(); }, 100);
            },
            page: this
        });

        listenToPageDirty((opt) => {
            if (opt.fieldName == 'ButtonModel.isActive') return;

            this.isDirty(true);
        });
    }

    get currentItems() {
        if (this.itemsRoot()) {
            return this.itemsRoot().subs;
        } else {
            return this.descriptor.content().items;
        }
    }

    onInit() {
        this.button(new ButtonModel(this.getServerSideData('button')));

        if (this.button().descriptor() && !this.button().descriptor().toolBtnsStyle()) {
            beginNoTracking(this.button().descriptor());
            this.button().descriptor().toolBtnsStyle('i');
            endNoTracking(this.button().descriptor());
        }

        if (this.button().design() && !this.button().design().buttonIconType()) {
            beginNoTracking(this.button().design());
            this.button().design().buttonIconType('');
            endNoTracking(this.button().design());
        }

        for (const prop in this.button().design()) {
            if (ko.isObservable(this.button().design()[prop])) {
                this.button().design()[prop].subscribe(() => this.updatePreview());
            }
        }

        $(document).on('change', '.change-track', (e) => {
            if (e.originalEvent) { // this should check the user action?
                this.updatePreview();
            }
        });
    }

    selectItem(item, goDeeperIfNeeded = true) {
        this.selectedItem(null);
        this.selectedItem(item);

        if (ko.unwrap(item.type) == 'grp' && goDeeperIfNeeded) {
            this.itemsRoot(item);
        }
    }

    goToRoot() {
        this.itemsRoot(null);
    }

    get descriptor() {
        const btn = ko.unwrap(this.button);

        if (!btn) return null;

        return ko.unwrap(btn.descriptor);
    }

    ensureContentFilled() {
        if (!this.descriptor.content()) {
            this.descriptor.content(new ButtonContentDescriptor())
        }
    }

    addItem(type) {
        this.ensureContentFilled();

        const newItem = new ButtonItemDescriptor();
        newItem.type(type);
        newItem.id(createUUID());
        this.currentItems.push(newItem);

        this.selectItem(newItem);

        this.updatePreview();
    }

    removeItem(item, ev) {
        ev.stopPropagation();

        this.currentItems.remove(item);
        if (this.selectedItem() === item) {
            this.selectedItem(null);
        }

        this.updatePreview();
    }

    saveAll() {
        if (this.button().descriptor() && this.button().descriptor().content() && this.button().descriptor().content().items) {
            for (const item of this.button().descriptor().content().items()) {
                if (item && item.id && !item.id()) {
                    beginNoTracking(item);
                    item.id(createUUID());
                    endNoTracking(item);
                }

                if (item.subs && item.subs()) {
                    for (const subItem of item.subs()) {
                        if (subItem && subItem.id && !subItem.id()) {
                            beginNoTracking(subItem);
                            subItem.id(createUUID());
                            endNoTracking(subItem);
                        }
                    }
                }
            }
        }

        const btnJs = this.button().toJS();
        clearBtnJs(btnJs);

        this.startSubmitting('save');
        $api.buttons.saveAll(
            { projectCode: auth.project.UniqueCode },
            btnJs,
            resp => {
                this.stopSubmitting('save');
                this.isDirty(false);
                resolvePageDirty();
                this.showToast('Button saved.');
            }
        );
    }

    getDesignConfig() {
        return JSON.parse(JSON.stringify(this.button().design().toJS()));
    }

    updatePreview() {
        /** @type {HTMLIFrameElement} */
        const el = document.getElementById('previewer');

        const btnJs = this.button().toJS();
        clearBtnJs(btnJs);

        el.contentWindow.postMessage({
            action: 'update',
            type: 'buttonv2',
            design: this.getDesignConfig(),
            descriptor: JSON.parse(JSON.stringify(btnJs.descriptor)),//JSON.parse(JSON.stringify(this.button().descriptor().toJS())),
            language: this.selectedLanguage(),
            smallHeight: window.matchMedia('(max-height: 960px)').matches
        });
    }

    setActivity() {
        if (this.button().isActive() === false) {
            $api.buttons.deactivate(
                { projectCode: auth.project.UniqueCode },
                {},
                () => {
                    //this.button().isActive(false);
                    this.showToast('The Life Ring Button is deactivated now.');
                }
            );
        } else {
            $api.buttons.activate(
                { projectCode: auth.project.UniqueCode },
                {},
                () => {
                    //this.button().isActive(true);
                    this.showToast('The Life Ring Button is activate now.');
                }
            );
        }
    }

    getTypeDisplayName(observable) {
        return ko.computed(() => {
            const val = ko.unwrap(observable);

            if (val == 'tour') return 'fas fa-directions';
            if (val == 'grp') return 'fas fa-layer-group';
            if (val == 'h') return 'fas fa-heading';
            if (val == 'link') return 'fas fa-link';
            if (val == 'vm') return 'fas fa-video';
            if (val == 'kb-article') return 'fas fa-file-alt';

            return 'unknown';
        });
    }

    bindLocalizableProp(observable, defaultVal) {
        return ko.computed({
            read: () => {
                var val = observable();
                if (!val) {
                    return defaultVal;
                }

                const res = ko.unwrap(observable()[this.selectedLanguage()]);

                if (res === '' || !res) return defaultVal;

                return res;
            },
            write: (val) => {
                var curV = observable();

                if (!curV) {
                    curV = {};
                }

                curV[this.selectedLanguage()] = val;

                observable(curV);
            }
        });
    }

    onRenderSelect(value, text) {

    }
}

export default ButtonOverviewView;

class LifeRingItemsList {
    constructor(params, instParams) {
        this.selectedItem = instParams.selectedItem;
        this.selectItem = instParams.selectItem;
        this.getTypeDisplayName = instParams.getTypeDisplayName;
        this.bindLocalizableProp = instParams.bindLocalizableProp;
        this.removeItem = instParams.removeItem;
        this.onUpdated = instParams.onUpdated;

        this.array = params.$raw.array();
    }

    listUpdated() {
        this.onUpdated && this.onUpdated();
    }
}

function clearBtnJs(btnJs) {
    if (btnJs.descriptor.content && btnJs.descriptor.content.items) {
        for (const item of btnJs.descriptor.content.items) {
            if (item.opts) {
                delete item.opts.parentParams;
            }
            item.opts = JSON.stringify(item.opts);
            if (item.subs) {
                for (const sub of item.subs) {
                    if (sub.opts) {
                        delete sub.opts.parentParams;
                    }
                    sub.opts = JSON.stringify(sub.opts);
                }
            }
        }
    }
}